import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {Container, Text, Wrap} from "./styled";

export const WhoWeAre = ({title, description}) => {
    return (
        <Container>
            <Wrap>
                <SectionTitle>{title}</SectionTitle>
                <Text>{description}</Text>
            </Wrap>
        </Container>
    )
}